import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M5.62011 45.7118C5.62011 45.7118 8.69012 39.2118 9.28012 33.4918C9.87012 27.7718 9.79012 14.4718 16.4901 10.7018C21.1901 8.06181 26.2701 14.3418 34.1101 13.3418C43.4401 12.1618 40.5701 6.73181 40.5701 6.73181L45.8601 10.8618C45.8601 10.8618 47.7301 6.59181 46.1501 4.92181C44.9901 3.69181 39.8201 0.68181 26.1201 1.56181C12.4101 2.44181 6.71011 13.5118 5.62011 16.6418C-0.779888 35.1418 1.90011 40.4218 5.62011 45.7118Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M54.8101 16.6418C54.2001 14.8918 52.4701 8.88185 47.0301 7.89185L45.1201 10.3718C51.1801 14.5918 50.5801 27.9519 51.1501 33.4919C51.7401 39.2119 54.8101 45.7119 54.8101 45.7119C58.5301 40.4219 61.2101 35.1418 54.8101 16.6418Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M47.9702 12.7917C47.9702 12.7917 50.7102 13.8917 52.2802 19.6217C53.8502 25.3417 54.6702 31.7318 58.0002 32.8318"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M45.8601 10.8618C45.8601 10.8618 51.3401 11.4718 53.2601 17.6318C54.8601 22.7718 55.8401 27.9818 58.0001 27.3218"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M50.7102 23.5818C50.7102 23.5818 52.3102 38.5518 58.3802 38.9918"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M10.9601 18.0818C10.9601 18.0818 6.50013 27.1118 2.38013 27.9918"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M10.18 23.1418C10.18 23.1418 5.91005 31.7318 1.80005 32.8318"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M9.98001 31.0718C9.98001 31.0718 5.69002 37.8418 2.77002 39.8818"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M38.2201 11.6918C38.2201 11.6918 35.7201 13.0118 29.2601 8.72181C22.8001 4.43181 17.8101 4.43181 15.3101 5.42181"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M10.6101 9.38189C10.6101 9.38189 15.6001 5.75188 22.6501 7.89188C29.7001 10.0419 28.8201 14.0019 35.4301 13.3419"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M24.5601 2.28174C24.5601 2.28174 29.8501 2.28174 33.5201 5.58174C37.1901 8.88174 39.1001 11.1917 40.5701 10.0417"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
    </g>
  )
}
